import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Colours, MessagePropType } from '@ratehub/base-ui';
import classNames from 'classnames';


function ProductFeatureList({ items, className, ...otherProps }) {
    return (
        <Container
            className={classNames('rh-display-grid', 'rh-text-s', 'rh-m-0', 'leading-s', 'rh-box-sizing-border-box', className)}
            {...otherProps}
        >
            <For
                each="item"
                of={items}
                index="index"
            >
                <dt
                    key={index}
                    className={classNames(COMMON_DT_DD_CLASS_NAMES, 'rh-pr-1', item.keyClassName)}
                >
                    {item.key}
                </dt>
                <dd
                    key={`${index}D`}
                    className={classNames(COMMON_DT_DD_CLASS_NAMES, 'rh-ml-0', item.valueClassName)}
                >
                    {item.value}
                </dd>
            </For>
        </Container>
    );
}

ProductFeatureList.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            key: MessagePropType.isRequired,
            keyClassName: PropTypes.string,
            value: MessagePropType.isRequired,
            valueClassName: PropTypes.string,
        }),
    ).isRequired,
    className: PropTypes.string,
};

const COMMON_DT_DD_CLASS_NAMES = 'rh-bb-1px-solid-stone rh-py-0_75 rh-px-0_5';


const Container = styled.dl`
    grid-template-columns: auto auto;
    grid-template-rows: auto;
    line-height: 1.2;

    dt.draw-attention,
    dd.draw-attention {
        background-color: ${Colours.YUZU_LIGHTEST};
        border: 1px solid ${Colours.YUZU};
    }

    dt.draw-attention {
        border-radius: 8px 0 0 8px;
        border-right: none;
    }

    dd.draw-attention {
        border-radius: 0 8px 8px 0;
        border-left: none;
    }
`;

export default ProductFeatureList;
